import React from "react";
import { getCalendarDayPopupPlacement } from "../../utils/calendarDayPopupPlacement";
import { formatCalendarDayAriaLabel } from "../../utils/calendarDayCell";
import CalendarDayHoverPopup from "./CalendarDayHoverPopup";

const CalendarDayCell = ({
  date,
  dayIdx,
  rows,
  selected,
  isAdmin,
  today,
  isHovered,
  onHoverChange,
  onSelectDate,
  className,
  children,
}) => {
  const hasAssessments = rows.length > 0;
  const placement = getCalendarDayPopupPlacement(dayIdx);

  return (
    <div
      className="relative"
      onMouseEnter={() => onHoverChange(hasAssessments)}
      onMouseLeave={() => onHoverChange(false)}
    >
      <button
        type="button"
        aria-label={formatCalendarDayAriaLabel(date)}
        aria-pressed={selected}
        className={className}
        onClick={() => onSelectDate(date)}
      >
        {children}
      </button>
      {isHovered && hasAssessments ? (
        <div
          className={`pointer-events-auto absolute isolate z-[200] ${placement.horizontal.className} ${placement.vertical}`}
          style={placement.horizontal.centered ? { transform: "translateX(-50%)" } : undefined}
        >
          <CalendarDayHoverPopup rows={rows} isAdmin={isAdmin} today={today} />
        </div>
      ) : null}
    </div>
  );
};

export default CalendarDayCell;
